import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, TransitionGroup as _TransitionGroup, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "w-full h-full p-4 flex flex-col justify-center space-y-3 overflow-hidden" }

import { onMounted, onUnmounted, ref, watch } from "vue";

type LogItem = {
  id: number;
  icon: string;
  color: string;
  width: string;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'StepTwoAnimation',
  props: {
    isHovering: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const icons = {
  observation: "i-heroicons-eye",
  directWork: "i-heroicons-academic-cap",
  task: "i-heroicons-check-circle",
};

const colors = ["bg-blue-400", "bg-green-400", "bg-indigo-400", "bg-amber-400"];
const textColors = ["text-blue-400", "text-green-400", "text-indigo-400", "text-amber-400"];

let idCounter = 0;
const createRandomLog = (): LogItem => {
  const randomIndex = Math.floor(Math.random() * colors.length);
  const type = ["observation", "directWork", "task"][
    Math.floor(Math.random() * 3)
  ] as keyof typeof icons;
  return {
    id: idCounter++,
    icon: icons[type],
    color: `${colors[randomIndex]} ${textColors[randomIndex]}`,
    width: `${Math.floor(Math.random() * 40) + 50}%`,
  };
};

const logs = ref<LogItem[]>([]);
let animationFrameId: number | null = null;
let lastUpdateTime = 0;
let nextDelay = 0;

const animationLoop = (timestamp: number) => {
  if (!animationFrameId) return;

  if (!lastUpdateTime) {
    lastUpdateTime = timestamp;
  }

  const deltaTime = timestamp - lastUpdateTime;

  if (deltaTime > nextDelay) {
    lastUpdateTime = timestamp;
    nextDelay = 850; // New random delay

    logs.value.pop();
    logs.value.unshift(createRandomLog());
  }

  animationFrameId = requestAnimationFrame(animationLoop);
};

const startFlux = () => {
  if (animationFrameId) return;
  lastUpdateTime = 0;
  nextDelay = 0;
  animationFrameId = requestAnimationFrame(animationLoop);
};

const stopFlux = () => {
  if (animationFrameId) {
    cancelAnimationFrame(animationFrameId);
    animationFrameId = null;
  }
};

watch(
  () => props.isHovering,
  (isHovering) => {
    if (isHovering) {
      startFlux();
    } else {
      stopFlux();
    }
  },
);

onMounted(() => {
  const initialLogsCount = 5;
  for (let i = 0; i < initialLogsCount; i++) {
    logs.value.push(createRandomLog());
  }
});

onUnmounted(() => {
  stopFlux();
});

return (_ctx: any,_cache: any) => {
  const _component_UIcon = _resolveComponent("UIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_TransitionGroup, {
      name: "flux",
      tag: "div",
      class: "relative"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(logs.value, (log) => {
          return (_openBlock(), _createElementBlock("div", {
            key: log.id,
            class: "flex items-center space-x-3 h-8"
          }, [
            _createVNode(_component_UIcon, {
              name: log.icon,
              class: _normalizeClass(["shrink-0 text-lg", log.color.split(' ')[1]])
            }, null, 8, ["name", "class"]),
            _createElementVNode("div", {
              class: _normalizeClass(["h-3.5 rounded-full", log.color.split(' ')[0]]),
              style: _normalizeStyle({ width: log.width })
            }, null, 6)
          ]))
        }), 128))
      ]),
      _: 1
    })
  ]))
}
}

})